import ajax from '@/utils/ajax';
import { getQueryVariable, generateRequestId } from '@/utils/util';
import Vue from 'vue';
import clone from 'clone';
import { MESSAGE_TYPE } from '@/constants';
import { API } from '../../utils/api';

const $e = Vue.prototype.$eventHub;
const $s = Vue.prototype.$socket;

const visitorListUrl = API.GetRecentContact; // 联系人列表url
const historyUrl = API.GetMsgRecord; // 联系人历史聊天记录
const robotInfoUrl = API.DescribeRobotInfo; // 机器人信息
const msgReadedEvent = 'read'; // ws消息已读
const msgEvent = 'reply'; // ws新消息 || 搜索回复消息
const msgSned = 'send'; // ws发消息
const msgSearch = 'search'; // ws搜索
const sessionClose = 'close_session'; // 结束会话
const sessionAbstract = 'abstract'; // 会话摘要
const sessionSummary = 'summary'; // 会话小结
const referenceEvent = 'reference'; // 参考来源

const systemEventsMax = 100; // 系统事件栈长度
const historyFetchCount = 15; // 单次拉取历史条数
const msgSendTimeout = 120000; // 发送消息超时ms
let visitorListInited = false; // 列表已初始化
let cache = null; // 缓存
let timeoutTasks = {}; // 超时任务管理

class Data {
    constructor () {
        cache = {
            searchKeywords: '', // 搜索关键词
            systemEvents: [], // 系统事件栈
            myInfo: '', // 本人信息
            chatInfo: {}, // 当前对话人信息
            robotInfo: {
                is_available: true,
                name: '',
                avatar: '',
                bot_biz_id: '',
                session_id: ''
            }, // 当前机器人信息
            visitorList: [], // 联系人列表
            visitorMap: {}, // 联系人映射关系
            chatsContent: {}, // 会话聊天内容
            latestVisitors: [], // 最近20个联系人
            searchInfo: {}, // 搜索问题
            visitorStatus: {}, // 联系人接入状态
            reference: {}, // 来源
            robotMsg: {}, // 机器人消息
            transferInfo: {} // 转人工状态
        };
    }
    init () {
        this.queryConfigInfo();
        this.initVisitorList();
        this.listenNewmsg();
        this.listenSessionMsg();
        this.listenReference();
        this.listenSessionClosed();
        this.listenSessionTransfer();
        this.listenErrorMsgByType();
    }
    setSystemEvents (data) {
        cache.systemEvents.unshift(data);
        if (cache.systemEvents.length > systemEventsMax) {
            cache.systemEvents.length = systemEventsMax;
        }
    }
    getSystemEvents () {
        return cache.systemEvents;
    }
    getHistoryFetchCount () {
        return historyFetchCount;
    }
    getMsg (session_id) {
        return cache.chatsContent[session_id] || [];
    }
    getCache () {
        return cache;
    }
    getChatsContent () {
        return cache.chatsContent || {};
    }
    setMyInfo (info) {
        info && (cache.myInfo = info);
    }
    getMyInfo () {
        return cache.myInfo;
    }
    setRobotInfo (info) {
        info && (cache.robotInfo = info);
    }
    getRobotInfo () {
        return cache.robotInfo;
    }
    handleCopySearchMsg () {
        let id = cache.searchInfo.id;
        let info = id ? cache.searchInfo[id] : {};
        let content = info.content || '';
        $e.$emit('data_answerCopySearchMsg', content);
    }
    // 获取基础配置
    queryConfigInfo () {
        console.log('queryConfigInfo');
        const botBizId = getQueryVariable('bot_biz_id');
        if (!botBizId) {
            $e.$emit('data_robotError');
            Vue.prototype.$message.error('缺少应用ID，请重试！');
            return;
        }
        ajax.post(robotInfoUrl, {
            bot_biz_id: botBizId // 密文机器人id
        }).then((res) => {
            this.setRobotInfo(res);
            $e.$emit('data_robotInfoChange', this.getRobotInfo());
        }).catch(e => {
            $e.$emit('data_robotError');
            Vue.prototype.$message.error('获取应用信息失败，请重试！');
        });
    }
    setChatInfo (info) {
        info && (cache.chatInfo = info);
        this.setReaded();
        $e.$emit('data_currentVisitorChange', info);
        cache.latestVisitors.unshift(info.session_id);
        if (cache.latestVisitors.length > 2) {
            cache.latestVisitors.length = 2;
        }
        this.releaseCache();
    }
    getChatInfo () {
        return cache.chatInfo;
    }
    handleSearch (keywords) {
        keywords && (cache.searchKeywords = keywords);
        // cache.searchInfo = {};
        let request_id = generateRequestId();
        const curChatInfo = this.getChatInfo();
        let session_id = curChatInfo.session_id;
        cache.searchInfo.id = request_id;
        cache.searchInfo[request_id] = {};
        $s.emit(msgSearch, {
            session_id,
            request_id,
            content: cache.searchKeywords
        });
    }
    listenReference () {
        $s.on(referenceEvent, (data) => {
            data.record_id && (cache.reference[data.record_id] = {
                ...data
            });
            $e.$emit('data_referenceUpdate', cache.reference);
        });
    }
    listenSessionMsg () {
        let handler = (data, msg_type) => {
            // 数据组装
            if (!cache.visitorStatus[data.session_id] && msg_type === 'abstract') {
                data.enter = true;
                cache.visitorStatus[data.session_id] = true;
            }
            if (cache.robotMsg[data.record_id] === undefined) {
                cache.robotMsg[data.record_id] = 0;
            } else {
                cache.robotMsg[data.record_id]++;
            }
            this.msgContentListAssamble(data.session_id, [{
                record_id: data.record_id,
                content: data.content,
                timestamp: data.timestamp,
                is_from_self: false,
                is_evil: data.is_evil,
                is_final: data.is_final,
                msg_type: msg_type,
                enter: data.enter
            }]);
            if (data.session_id === this.getChatInfo().session_id) {
                this.setReaded();
            }
        };
        $s.on(sessionAbstract, (data) => {
            handler(data, 'abstract');
        });
        $s.on(sessionSummary, (data) => {
            handler(data, 'summary');
        });
    }
    listenErrorMsgByType () {
        $s.on('error', (data) => {
            if (cache.searchInfo.id && cache.searchInfo.id === data.request_id) {
                $e.$emit('data_searchError', data.request_id);
            }
        });
    }
    listenNewmsg () {
        $s.on(msgEvent, (data) => {
            // c侧消息不可评价
            if (!cache.visitorMap[data.session_id] && !data.can_rating) {
                cache.visitorMap[data.session_id] = {
                    session_id: data.session_id,
                    nick_name: data.from_name,
                    avatar: data.from_avatar
                };
            }
            // 来自自己的消息才有request_id 搜索除外
            if (!this.getChatInfo().session_id && !data.is_from_self && data.session_id) {
                this.setChatInfo({
                    session_id: data.session_id,
                    nick_name: cache.visitorMap[data.session_id].nick_name,
                    avatar: cache.visitorMap[data.session_id].avatar
                });
            }
            if (!data.is_from_self && data.request_id) {
                if (!(cache.searchInfo.id && cache.searchInfo.id === data.request_id)) {
                    data.request_id = '';
                }
            }
            let updateVisitorList = (data) => {
                // 用作是否插入新人的标志
                let currentContent = clone(cache.chatsContent);
                let handleVisitorStatus = (data) => {
                    if (!cache.visitorStatus[data.session_id]) {
                        data.enter = true;
                        cache.visitorStatus[data.session_id] = true;
                    }
                    return data;
                };
                data = handleVisitorStatus(data);
                let handleVisitorList = (data, currentContent) => {
                    if (!currentContent[data.session_id]) {
                        // 新人插入联系人列表
                        cache.visitorList.unshift({
                            request_id: data.request_id,
                            session_id: data.session_id,
                            avatar: cache.visitorMap[data.session_id].avatar,
                            nick_name: data.from_name,
                            last_record: {
                                ...data,
                                has_read: false
                            }
                        });
                    } else {
                        // 老人更新last_record 对已发送消息的确认不更新
                        if (!data.request_id) {
                            let moveIndex = 0;
                            cache.visitorList.forEach((visitor, index) => {
                                if (visitor.session_id === data.session_id) {
                                    moveIndex = index;
                                    cache.visitorList[index].last_record = {
                                        ...data,
                                        has_read: false
                                    };
                                }
                            });
                            // 移到首位
                            if (moveIndex) {
                                let tempVisitor = cache.visitorList[moveIndex];
                                cache.visitorList.splice(moveIndex, 1);
                                cache.visitorList.unshift(tempVisitor);
                            }
                        }
                    }
                    // 抛出联系人列表事件
                    $e.$emit('data_visitorListUpdate', cache.visitorList);
                };
                // 数据组装
                this.msgContentListAssamble(data.session_id, [{ ...data }], false, () => { handleVisitorList(data, currentContent); });
                if (data.session_id === this.getChatInfo().session_id) {
                    this.setReaded();
                }
            };
            // 搜索
            if (cache.searchInfo.id && cache.searchInfo.id === data.request_id) {
                cache.searchInfo[data.request_id] = {
                    ...data
                };
                $e.$emit('data_search', cache.searchInfo);
            } else if (cache.searchInfo[data.request_id] && cache.searchInfo.id !== data.request_id) {
                // 不需要做
                console.log('no current search');
            } else if (visitorListInited) {
                updateVisitorList(data);
            } else {
                // 列表还未初始化，初始化后插入
                $e.$on('visitorListInit', () => {
                    updateVisitorList(data);
                });
            }
        });
    }
    // 监听会话结束事件
    listenSessionClosed () {
        $s.on('session_closed', (data) => {
            // 输入框置灰，不能点击
            cache.transferInfo[data.session_id] = false;
            // 抛出转人工变化事件
            $e.$emit('data_transferInfoChange', cache.transferInfo);
        });
    }
    // 监听会话转接事件
    listenSessionTransfer () {
        $s.on('transfered', (data) => {
            // 输入框置灰，不能点击
            cache.transferInfo[data.session_id] = true;
            // 抛出转人工变化事件
            $e.$emit('data_transferInfoChange', cache.transferInfo);
        });
    }
    setReaded () {
        const curChatInfo = this.getChatInfo();
        let session_id = curChatInfo.session_id;
        let msgs = cache.chatsContent[session_id];
        let last_record = msgs && msgs[msgs.length - 1];
        if (session_id && last_record) {
            if (!last_record.is_from_self && last_record.is_final && last_record.request_id && !last_record.has_read) {
                $s.emit(msgReadedEvent, {
                    request_id: last_record.request_id,
                    last_record_id: last_record.record_id
                });
            }
            cache.chatsContent[session_id][msgs.length - 1].has_read = true;
            // 设置联系人列表已读
            cache.visitorList.forEach((visitor, index) => {
                if (visitor.session_id === session_id) {
                    cache.visitorList[index].last_record.has_read = true;
                }
            });
            // 抛出联系人列表事件
            $e.$emit('data_visitorListUpdate', cache.visitorList);
            $e.$emit('data_msgContentChange', {
                session_id: session_id,
                chatsContent: cache.chatsContent
            });
        }
    }
    initVisitorList () {
        ajax.post(visitorListUrl).then(res => {
            let list = res.contacts;
            list.forEach(visitor => {
                visitor.session_id = visitor.session_id;
            });
            if (list && list.length) {
                list.forEach(visitor => {
                    cache.visitorMap[visitor.session_id] = {
                        session_id: visitor.session_id,
                        nick_name: visitor.nick_name,
                        avatar: visitor.avatar
                    };
                });
                cache.visitorList = list;
                this.initChatsContent();
                this.setChatInfo({
                    session_id: list[0].session_id,
                    nick_name: cache.visitorMap[list[0].session_id].nick_name,
                    avatar: cache.visitorMap[list[0].session_id].avatar
                });
                this.getHistory();
            }
            // ChatInfo visitorList ChatsContent
            visitorListInited = true;
            $e.$emit('data_visitorListInit', this.getVisitorList().visitorList);
        }).catch(e => {
            $e.$emit('data_visitorListError', e);
            Vue.prototype.$message.error('获取联系人列表失败，请重试！');
            visitorListInited = true;
            $e.$emit('data_visitorListInit', this.getVisitorList().visitorList);
        });
    }
    getTransferHistory () {
        console.log('getTransferHistory getTransferHistory getTransferHistory getTransferHistory');
        const curChatInfo = this.getChatInfo();
        let session_id = curChatInfo.session_id;
        let oldestMsg;
        if (cache.chatsContent[session_id]) {
            const msgLength = cache.chatsContent[session_id].length;
            oldestMsg = cache.chatsContent[session_id] && cache.chatsContent[session_id][msgLength - 1];
        }
        if (session_id) {
            ajax.post(historyUrl, {
                session_id: session_id,
                last_record_id: oldestMsg.record_id,
                count: 100,
                type: window.userType
            }).then(res => {
                let list = res.records;
                if (list && list.length) {
                    list = list.map((r) => {
                        return {
                            ...r,
                            is_history: true,
                            is_final: true
                        };
                    });
                    this.msgContentListAssamble(session_id, list, null, null, true);
                }
                $e.$emit('data_history', cache.chatsContent[session_id]);
            }).catch(e => {
                $e.$emit('data_historyError', e);
                $e.$emit('data_historyError');
                Vue.prototype.$message.error('获取历史记录失败，请重试！');
            });
        }
    }
    getHistory () {
        console.log('getHistory getHistory getHistory');
        const curChatInfo = this.getChatInfo();
        let session_id = curChatInfo.session_id;
        let oldestMsg = cache.chatsContent[session_id] && cache.chatsContent[session_id][0];
        if (session_id) {
            ajax.post(historyUrl, {
                session_id: session_id,
                last_record_id: oldestMsg.record_id,
                // timestamp: oldestMsg.timestamp,
                count: historyFetchCount,
                type: window.userType
            }).then(res => {
                let list = res.records;
                if (list && list.length) {
                    list = list.map((r) => {
                        return {
                            ...r,
                            is_history: true,
                            is_final: true
                        };
                    });
                    this.msgContentListAssamble(session_id, list, null, null, true);
                }
                $e.$emit('data_history', cache.chatsContent[session_id]);
            }).catch(e => {
                console.log(e);
                $e.$emit('data_historyError', e);
                Vue.prototype.$message.error('获取历史记录失败，请重试！');
            });
        }
    }
    initChatsContent () {
        cache.visitorList.forEach(visitor => {
            this.msgContentListAssamble(visitor.session_id, [visitor.last_record]);
        });
    }
    msgContentListAssamble (session_id, msgList, immediately, visitorListCB, isHistory) {
        // history ajax arr
        // new ws obj
        let isOldPipeMsgDonotUpdateVisitorList = false;
        if (!cache.chatsContent[session_id]) {
            // 单条联系人列表最近消息
            cache.chatsContent[session_id] = msgList;
        } else {
            if (msgList.length === 1) {
                let newMsg = msgList[0];
                if (newMsg.request_id || (newMsg.msg_type && cache.robotMsg[newMsg.record_id])) {
                    // 单条回复发送消息request_id 覆盖 纠正时间戳 || 摘要小结
                    if (immediately) {
                        // 发送消息前端插入
                        cache.chatsContent[session_id].push(newMsg);
                    } else {
                        // 服务端确认覆盖
                        timeoutTasks[newMsg.request_id] && clearTimeout(timeoutTasks[newMsg.request_id]);
                        let currentList = cache.chatsContent[session_id];
                        for (let i = currentList.length - 1; i >= 0; i--) {
                            // record_id 摘要流式覆盖
                            if (newMsg.request_id === currentList[i].request_id || newMsg.record_id === currentList[i].record_id) {
                                let { request_id, ...args } = newMsg;
                                cache.chatsContent[session_id][i] = {
                                    ...args,
                                    has_read: true,
                                    quit: currentList[i].quit
                                };
                                break;
                            }
                        }
                    }
                } else {
                    // 单条新消息
                    // 倒序遍历插入
                    let currentList = cache.chatsContent[session_id];
                    for (let i = currentList.length - 1; i >= 0; i--) {
                        if (newMsg.timestamp >= currentList[i].timestamp && newMsg.record_id !== currentList[i].record_id) {
                            cache.chatsContent[session_id].splice(i + 1, 0, {
                                ...newMsg,
                                has_read: false
                            });
                            break;
                        } else if (newMsg.record_id === currentList[i].record_id) {
                            // 流式覆盖
                            if (i < currentList.length - 1) {
                                isOldPipeMsgDonotUpdateVisitorList = true;
                            }
                            cache.chatsContent[session_id][i] = {
                                ...newMsg,
                                has_read: true,
                                enter: cache.chatsContent[session_id][i].enter,
                                quit: cache.chatsContent[session_id][i].quit
                            };
                            break;
                        } else if (i === 0 && newMsg.timestamp <= currentList[i].timestamp && newMsg.record_id !== currentList[i].record_id) {
                            cache.chatsContent[session_id].splice(0, 0, {
                                ...newMsg,
                                has_read: false
                            });
                        }
                    }
                }
            } else {
                let oldMsgCurrent = cache.chatsContent[session_id][0];
                let newMsgHistory = msgList[msgList.length - 1];
                if (newMsgHistory.timestamp < oldMsgCurrent.timestamp) {
                    cache.chatsContent[session_id] = [].concat(msgList).concat(cache.chatsContent[session_id] || []);
                } else {
                    // 可能重复的历史消息
                    msgList.reverse().forEach(msg => {
                        for (let i = 0; i < cache.chatsContent[session_id].length; i++) {
                            if (msg.record_id === cache.chatsContent[session_id][i].record_id) {
                                // 重复覆盖
                                cache.chatsContent[session_id][i] = msg;
                                break;
                            } else if (msg.timestamp <= cache.chatsContent[session_id][i].timestamp) {
                                cache.chatsContent[session_id].splice(i, 0, msg);
                                break;
                            } else if (i === cache.chatsContent[session_id].length - 1 && msg.timestamp >= cache.chatsContent[session_id][i].timestamp) {
                                cache.chatsContent[session_id].splice(i + 1, 0, msg);
                            }
                        }
                    });
                }
            }
        }
        $e.$emit('data_msgContentChange', {
            session_id: session_id,
            chatsContent: cache.chatsContent,
            type: isHistory ? MESSAGE_TYPE.WORKBENCH_HISTORY : '' // WH 历史记录
        });
        !isOldPipeMsgDonotUpdateVisitorList && visitorListCB && visitorListCB();
    }
    getVisitorList () {
        return {
            visitorList: cache.visitorList,
            visitorListInited
        };
    }
    handleQuit () {
        const curChatInfo = this.getChatInfo();
        let session_id = curChatInfo.session_id;
        // 没有会话管理，放开结束会话
        // if (cache.visitorStatus[session_id]) {
        for (let i = 0; i <= cache.visitorList.length - 1; i++) {
            if (cache.visitorList[i].session_id === session_id) {
                cache.visitorList[i].last_record.quit = true;
                break;
            }
        }
        let currentList = cache.chatsContent[session_id];
        let last_record_id = '';
        cache.chatsContent[session_id][currentList.length - 1].quit = true;
        for (let i = cache.chatsContent[session_id].length - 1; i >= 0; i--) {
            if (cache.chatsContent[session_id][i].record_id) {
                // 重复覆盖
                last_record_id = cache.chatsContent[session_id][i].record_id;
                break;
            }
        }
        cache.visitorStatus[session_id] = false;
        $e.$emit('data_visitorListUpdate', cache.visitorList);
        $e.$emit('data_msgContentChange', {
            session_id: session_id,
            chatsContent: cache.chatsContent
        });
        $s.emit(sessionClose, {
            session_id: session_id,
            last_record_id
        });
        // }
    }
    sendSearchMsg () {
        let id = cache.searchInfo.id;
        let info = id ? cache.searchInfo[id] : {};
        let content = info.content || '';
        this.sendMsg(content);
    }
    sendMsg (msg) {
        console.log('msgContent  msgContentmsgContentmsgContent');
        const curChatInfo = this.getChatInfo();
        let session_id = curChatInfo.session_id;
        let msgContent = {
            session_id: session_id,
            request_id: generateRequestId(),
            content: msg,
            last_record: {
                record_id: 'temp-' + Math.random(),
                content: msg,
                timestamp: parseInt(+new Date() / 1000),
                has_read: true,
                is_from_self: true,
                from_avatar: '', // 自己的头像
                can_rating: false
            }
        };
        // 老人更新last_record
        let moveIndex = 0;
        cache.visitorList.forEach((visitor, index) => {
            if (visitor.session_id === msgContent.session_id) {
                moveIndex = index;
                cache.visitorList[index].last_record = msgContent.last_record;
            }
        });
        // 移到首位
        if (moveIndex) {
            let tempVisitor = cache.visitorList[moveIndex];
            cache.visitorList.splice(moveIndex, 1);
            cache.visitorList.unshift(tempVisitor);
        }
        this.msgContentListAssamble(msgContent.session_id, [{
            request_id: msgContent.request_id,
            ...msgContent.last_record
        }], true);
        timeoutTasks[msgContent.request_id] = setTimeout(() => {
            this.msgContentListAssamble(msgContent.session_id, [{
                request_id: msgContent.request_id,
                ...msgContent.last_record,
                failed: true
            }]);
        }, msgSendTimeout);
        $s.emit(msgSned, {
            session_id: msgContent.session_id,
            request_id: msgContent.request_id,
            content: msgContent.last_record.content
        });
    }
    releaseCache () {
        // 发送失败发送中的不算在记录记数中
        if (cache.visitorList.length < 20) {
            return;
        }
        let latest100count = 0;
        cache.visitorList.forEach(visitor => {
            if (cache.latestVisitors.indexOf(visitor.session_id) > -1) {
                // 近20个用户(包含当前)保留全部记录
            } else if (cache.chatsContent[visitor.session_id].length > 30) {
                // 大于30条记录的用户
                // 少于30条记录的不做操作
                latest100count++;
                // if (latest100count <= 100) {
                if (latest100count <= 2) {
                    // 保留除近20个用户以外最近100个&记录超30条的用户的最近1000条记录
                    let count = 0;
                    let arr = [];
                    for (let i = cache.chatsContent[visitor.session_id].length - 1; i >= 0 && count <= 1000; i--) {
                        let msg = cache.chatsContent[visitor.session_id][i];
                        if (!msg.requestID && !msg.failed) {
                            arr.unshift(msg);
                            count++;
                        }
                    }
                    cache.chatsContent[visitor.session_id] = arr;
                } else {
                    // 这120个用户以外的用户保留最近30条记录
                    let count = 0;
                    let arr = [];
                    for (let i = cache.chatsContent[visitor.session_id].length - 1; i >= 0 && count <= 30; i--) {
                        let msg = cache.chatsContent[visitor.session_id][i];
                        if (!msg.requestID && !msg.failed) {
                            arr.unshift(msg);
                            count++;
                        }
                    }
                    cache.chatsContent[visitor.session_id] = arr;
                }
            }
            // 少于30条记录的不做操作
        });
        const curChatInfo = this.getChatInfo();
        let session_id = curChatInfo.session_id;
        $e.$emit('data_msgContentChange', {
            session_id: session_id,
            chatsContent: cache.chatsContent
        });
    }
    destroy () {
        // be careful to clear the cache to avoid errors
        this.releaseCache();
    }
}

var $d = new Data();
Vue.prototype.$cache = $d;
export default $d;



// WEBPACK FOOTER //
// ./src/manage/utils/Data.js